import styles from "./Header.module.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonButton from "../common/buttons/CommonButton/CommonButton";
import Gnb from "../common/navi/Gnb";
import logo from "./../../assets/images/logo.png";
import Mnb from "../common/mobileMenu/Mnb";
import { Default, Mobile } from "../../assets/mediaQuery/mediaQuery";

const NAVI_ARRAY = [
    {
        id: 0,
        value: "공간안내",
        name: "공간안내",
        navi: "/spaceguide",
    },
    {
        id: 1,
        value: "멤버십",
        name: "멤버십",
        navi: "/membership",
    },
];
const Header = () => {
    const [currentNav, setCurrentNav] = useState("");
    const navigate = useNavigate();

    return (
        <header className={styles.container}>
            <div className={styles.inner}>
                <div
                    className={styles.left}
                    onClick={(e) => {
                        navigate("/", { replace: true }); // replace 옵션 사용
                        setCurrentNav("");
                    }}
                >
                    <div className={styles.left__imgbox}>
                        <picture>
                            <source
                                srcSet="./../../assets/images/logo.webp"
                                type="image/webp"
                            />
                            <img
                                className={styles.left__img}
                                src={logo}
                                alt="스마트워크 로고"
                            />
                        </picture>
                    </div>
                </div>
                <Default>
                    <div className={styles.center}>
                        <Gnb navs={NAVI_ARRAY} setCurrentNav={setCurrentNav} />
                    </div>
                    <div className={styles.right}>
                        <div className={styles.right__button}>
                            <CommonButton
                                style={{ borderRadius: "100px" }}
                                theme="header"
                                color="black"
                                onClick={() => {
                                    navigate("/contact");
                                }}
                            >
                                방문 예약
                            </CommonButton>
                        </div>
                    </div>
                </Default>
                {/* 모바일 메뉴 */}
                <Mobile>
                    <div className={styles.mobile}>
                        <Mnb />
                    </div>
                </Mobile>
                {/* 모바일 메뉴 끝 */}
            </div>
        </header>
    );
};

export default Header;
